import { useState } from "react";
import { Link } from "react-router-dom";
import apiFetch from "../../../../shared/services/apiClient";
import { FiltrosBarra } from "./BalanceComprobacion";
import invoiceStyles from "../../invoices/styles/invoice.module.css";


const BASE = process.env.REACT_APP_API_URL ?? "";

async function descargarPDF(url, filename, setLoading, setError) {
  setLoading(true);
  setError("");
  try {
    const token = localStorage.getItem("access_token");
    const res = await window.fetch(`${BASE}${url}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!res.ok) {
      const body = await res.json().catch(() => ({}));
      throw new Error(body.detail || `Error ${res.status}`);
    }
    const blob = await res.blob();
    const href = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = href; a.download = filename; a.click();
    URL.revokeObjectURL(href);
  } catch (e) {
    setError(e.message);
  } finally {
    setLoading(false);
  }
}

// ── Modal de firma ────────────────────────────────────────────────────────────
function FirmaModal({ onConfirm, onCancel }) {
  const [incluirFirma, setIncluirFirma] = useState(true);
  const [campoFirma,   setCampoFirma]   = useState("");

  return (
    <div style={{ position:"fixed", inset:0, zIndex:1000,
      background:"rgba(0,0,0,0.75)", backdropFilter:"blur(4px)",
      display:"flex", alignItems:"center", justifyContent:"center" }}
      onClick={onCancel}>
      <div style={{ background:"#1f2937", border:"1px solid #374151",
        borderRadius:12, width:"min(460px,94vw)", padding:28 }}
        onClick={e => e.stopPropagation()}>
        <h3 style={{ color:"#f1f5f9", margin:"0 0 16px" }}>
          <i className="fa-solid fa-file-signature" style={{ marginRight:8, color:"#f97316" }}/>
          Opciones del PDF
        </h3>

        <label style={{ display:"flex", alignItems:"center", gap:10,
          cursor:"pointer", marginBottom:16 }}>
          <input type="checkbox" checked={incluirFirma}
            onChange={e => setIncluirFirma(e.target.checked)}
            style={{ accentColor:"#f97316", width:16, height:16 }}/>
          <div>
            <div style={{ color:"#e5ecf5", fontSize:"0.88rem", fontWeight:600 }}>
              Incluir firma del contador
            </div>
            <div style={{ color:"#6b7280", fontSize:"0.77rem" }}>
              Usa la firma configurada en Ajustes
            </div>
          </div>
        </label>

        <div style={{ marginBottom:20 }}>
          <label style={{ fontSize:"0.78rem", color:"#9ca3af",
            display:"block", marginBottom:6, fontWeight:600 }}>
            Nombre del segundo firmante (opcional)
          </label>
          <input type="text" value={campoFirma}
            onChange={e => setCampoFirma(e.target.value)}
            placeholder="Ej: María González, Presidenta"
            style={{ width:"100%", background:"#344152",
              border:"1px solid #364250", borderRadius:6,
              color:"#e5ecf5", padding:"8px 12px", fontSize:"0.85rem",
              boxSizing:"border-box" }}/>
        </div>

        <div style={{ display:"flex", gap:10, justifyContent:"flex-end" }}>
          <button onClick={onCancel}
            style={{ padding:"8px 18px", background:"rgba(55,65,81,0.4)",
              border:"1px solid #374151", borderRadius:7,
              color:"#9ca3af", cursor:"pointer" }}>
            Cancelar
          </button>
          <button onClick={() => onConfirm({ incluirFirma, campoFirma })}
            style={{ padding:"8px 18px", background:"#f97316",
              border:"none", borderRadius:7,
              color:"#fff", fontWeight:700, cursor:"pointer" }}>
            <i className="fa-solid fa-file-pdf" style={{ marginRight:6 }}/>
            Generar PDF
          </button>
        </div>
      </div>
    </div>
  );
}

// ── Helpers ───────────────────────────────────────────────────────────────────
const MESES = ["Enero","Febrero","Marzo","Abril","Mayo","Junio",
               "Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"];

function fmtLindo(iso) {
  if (!iso) return "—";
  const [y, m, d] = iso.split("-");
  return `${parseInt(d,10)} ${MESES[parseInt(m,10)-1]} ${y}`;
}

// Dado un DESDE calcula el último día del mismo mes
function finDeMes(desde) {
  if (!desde) return "";
  const [y, m] = desde.split("-").map(Number);
  const ultimo = new Date(y, m, 0); // día 0 del mes siguiente = último del mes actual
  return ultimo.toISOString().split("T")[0];
}

const SECCIONES = [
  { icon:"fa-chart-bar",        n:"01", label:"Estado de Resultados Integral",   desc:"Ingresos vs Gastos con notas",              color:"#f97316" },
  { icon:"fa-scale-balanced",   n:"02", label:"Estado de Situación Financiera",  desc:"Activos = Pasivos + Patrimonio",             color:"#60a5fa" },
  { icon:"fa-note-sticky",      n:"03", label:"Notas a los Estados Financieros", desc:"Desglose de subcuentas con detalles",        color:"#a78bfa" },
  { icon:"fa-users",            n:"04", label:"Anexo Cuentas por Cobrar",        desc:"Aging por filial: 1-30, 31-60, 61-90, +91", color:"#4ade80" },
  { icon:"fa-building",         n:"05", label:"Anexo Cuentas por Pagar",         desc:"Aging por proveedor",                        color:"#fb923c" },
  { icon:"fa-building-columns", n:"06", label:"Anexo Cuentas Bancarias",         desc:"Movimientos por cuenta bancaria",            color:"#34d399" },
];

// ── Componente principal ──────────────────────────────────────────────────────
export default function EstadoFinanciero() {
  const now       = new Date();
  // Primer día del mes actual
  const mesInicio = `${now.getFullYear()}-${String(now.getMonth()+1).padStart(2,"0")}-01`;
  // Último día del mes actual (calculado automáticamente)
  const mesFin    = finDeMes(mesInicio);

  const [fechaDesde, setFechaDesde] = useState(mesInicio);
  // "hasta" se recalcula automáticamente al cambiar "desde"
  const [fechaHasta, setFechaHasta] = useState(mesFin);
  const [loading,    setLoading]    = useState(false);
  const [error,      setError]      = useState("");
  const [showModal,  setShowModal]  = useState(false);

  // Al cambiar el DESDE → recalcula el fin de ese mes automáticamente
  function handleDesdeChange(val) {
    setFechaDesde(val);
    setFechaHasta(finDeMes(val));
  }

  function buildQS(opts = {}) {
    const qs = new URLSearchParams();
    if (fechaDesde) qs.set("fecha_desde", fechaDesde);
    if (fechaHasta) qs.set("fecha_hasta", fechaHasta);
    qs.set("incluir_firma", opts.incluirFirma ? "true" : "false");
    if (opts.campoFirma) qs.set("campo_firma", opts.campoFirma);
    return qs.toString();
  }

  function handleGenerar() { setShowModal(true); }

  function handleConfirm(opts) {
    setShowModal(false);
    const url = `/api/finance/reportes/estado-financiero/?${buildQS(opts)}`;
    const fn  = `estados_financieros_${fechaHasta.replace(/-/g,"")}.pdf`;
    descargarPDF(url, fn, setLoading, setError);
  }

  return (
    <>
      {/* ── Breadcrumb ── */}

      
          
        <span className={invoiceStyles.inactive}>
          <Link to="/">
            <span className={invoiceStyles.inactive}>Inicio /</span>
          </Link>
            <span className={invoiceStyles.active}> Estado Financiero</span>
        </span>
        <div>
          <h2 className="title mt-2 mb-2">Estado Financiero</h2>
          <p className="mb-3" style={{color:"#9ca3af"}}>PDF completo con todos los estados e informes financieros del período.</p>
        </div>

      {/* ── Panel selector de fechas ── */}
      <div style={{ background:"#1f2937", border:"1px solid #364250",
        borderRadius:12, padding:"22px 24px", marginBottom:24 }}>

        {error && (
          <div style={{ background:"rgba(248,113,113,0.08)",
            border:"1px solid rgba(248,113,113,0.25)", borderLeft:"3px solid #f87171",
            borderRadius:8, padding:"10px 14px", marginBottom:18,
            color:"#fca5a5", fontSize:"0.83rem",
            display:"flex", alignItems:"center", gap:8 }}>
            <i className="fa-solid fa-circle-exclamation"/>
            {error}
          </div>
        )}

        <div style={{ display:"grid",
          gridTemplateColumns:"1fr 1fr auto", gap:16, alignItems:"flex-end" }}>

          {/* DESDE */}
          <div>
            <label style={{ display:"block", fontSize:"0.68rem", fontWeight:700,
              letterSpacing:"1px", textTransform:"uppercase",
              color:"#6b7280", marginBottom:8 }}>
              Desde
            </label>
            <div style={{ background:"#111827", border:"1px solid #364250",
              borderRadius:8, padding:"10px 14px",
              display:"flex", alignItems:"center", gap:10 }}>
              <i className="fa-regular fa-calendar"
                 style={{ color:"#f97316", fontSize:"0.88rem", flexShrink:0 }}/>
              <input type="date" value={fechaDesde}
                onChange={e => handleDesdeChange(e.target.value)}
                style={{ background:"transparent", border:"none", outline:"none",
                  color:"#e5ecf5", fontSize:"0.88rem", fontWeight:600,
                  colorScheme:"dark", cursor:"pointer", flex:1, width:"100%" }}/>
            </div>
            <div style={{ fontSize:"0.72rem", color:"#4b5563", marginTop:4, paddingLeft:2 }}>
              {fmtLindo(fechaDesde)}
            </div>
          </div>

          {/* HASTA — solo lectura, se calcula automático */}
          <div>
            <label style={{ display:"block", fontSize:"0.68rem", fontWeight:700,
              letterSpacing:"1px", textTransform:"uppercase",
              color:"#6b7280", marginBottom:8 }}>
              Hasta
              <span style={{ marginLeft:6, fontWeight:400, color:"#4b5563",
                fontSize:"0.62rem", textTransform:"none", letterSpacing:0 }}>
                (fin de mes automático)
              </span>
            </label>
            <div style={{ background:"#111827", border:"1px solid #364250",
              borderRadius:8, padding:"10px 14px",
              display:"flex", alignItems:"center", gap:10,
              opacity:0.7 }}>
              <i className="fa-regular fa-calendar-check"
                 style={{ color:"#4ade80", fontSize:"0.88rem", flexShrink:0 }}/>
              <span style={{ color:"#e5ecf5", fontSize:"0.88rem",
                fontWeight:600, fontFamily:"monospace" }}>
                {fechaHasta}
              </span>
            </div>
            <div style={{ fontSize:"0.72rem", color:"#4b5563", marginTop:4, paddingLeft:2 }}>
              {fmtLindo(fechaHasta)}
            </div>
          </div>

          {/* Botón Actualizar */}
          <button onClick={handleGenerar} disabled={loading}
            style={{ background:"#f97316", border:"none", borderRadius:8,
              padding:"11px 22px", color:"#fff", fontWeight:700,
              fontSize:"0.88rem", cursor:loading?"not-allowed":"pointer",
              display:"flex", alignItems:"center", gap:9,
              boxShadow:"0 4px 16px rgba(249,115,22,0.28)",
              opacity:loading?0.7:1, whiteSpace:"nowrap",
              transition:"background 0.15s, box-shadow 0.15s" }}
            onMouseOver={e => { if(!loading) e.currentTarget.style.background="#ea6b10"; }}
            onMouseOut={e => { if(!loading) e.currentTarget.style.background="#f97316"; }}>
            <i className="fa-solid fa-rotate"/>
            Actualizar
          </button>
        </div>

        {/* Resumen período */}
        {fechaDesde && fechaHasta && (
          <div style={{ marginTop:16, paddingTop:14,
            borderTop:"1px solid rgba(255,255,255,0.05)",
            display:"flex", alignItems:"center", gap:8 }}>
            <i className="fa-solid fa-circle-info"
               style={{ color:"#4b5563", fontSize:"0.78rem" }}/>
            <span style={{ fontSize:"0.78rem", color:"#4b5563" }}>
              Período:{" "}
              <strong style={{ color:"#9ca3af" }}>
                {fmtLindo(fechaDesde)} — {fmtLindo(fechaHasta)}
              </strong>
            </span>
          </div>
        )}
      </div>

      {/* ── Secciones del PDF ── */}
      <div style={{ marginBottom:8 }}>
        <p style={{ margin:"0 0 16px", fontSize:"0.7rem", fontWeight:700,
          letterSpacing:"2px", textTransform:"uppercase",
          color:"#4b5563", textAlign:"center" }}>
          Contenido incluido en el PDF
        </p>

        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12 }}>
          {SECCIONES.map(({ icon, n, label, desc, color }) => (
            <div key={n}
              style={{ background:"#1f2937", border:"1px solid #364250",
                borderRadius:12, padding:"18px 20px",
                display:"flex", alignItems:"center", gap:14,
                position:"relative", overflow:"hidden",
                transition:"border-color 0.15s, transform 0.1s" }}
              onMouseOver={e => {
                e.currentTarget.style.borderColor = color + "55";
                e.currentTarget.style.transform = "translateY(-1px)";
              }}
              onMouseOut={e => {
                e.currentTarget.style.borderColor = "#364250";
                e.currentTarget.style.transform = "translateY(0)";
              }}>

              {/* Número decorativo de fondo */}
              <span style={{ position:"absolute", right:12, top:"50%",
                transform:"translateY(-50%)", fontSize:"3.8rem", fontWeight:900,
                fontFamily:"'Montserrat',sans-serif", color:color+"12",
                lineHeight:1, userSelect:"none", letterSpacing:"-2px",
                pointerEvents:"none" }}>
                {n}
              </span>

              {/* Ícono */}
              <div style={{ width:42, height:42, borderRadius:10, flexShrink:0,
                background:color+"14", border:`1px solid ${color}28`,
                display:"flex", alignItems:"center", justifyContent:"center" }}>
                <i className={`fa-solid ${icon}`}
                   style={{ color, fontSize:"1rem" }}/>
              </div>

              {/* Texto */}
              <div style={{ minWidth:0 }}>
                <div style={{ fontSize:"0.87rem", fontWeight:700,
                  color:"#e5ecf5", lineHeight:1.3, marginBottom:3 }}>
                  {label}
                </div>
                <div style={{ fontSize:"0.74rem", color:"#6b7280" }}>{desc}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* ── Botón principal ── */}
      <div style={{ marginTop:24, display:"flex", justifyContent:"center" }}>
        <button onClick={handleGenerar} disabled={loading}
          style={{ background:"#f97316", border:"none", borderRadius:10,
            padding:"13px 40px", color:"#fff", fontWeight:700, fontSize:"1rem",
            cursor:loading?"not-allowed":"pointer", opacity:loading?0.7:1,
            display:"flex", alignItems:"center", gap:10,
            boxShadow:"0 8px 28px rgba(249,115,22,0.32)",
            transition:"all 0.15s" }}
          onMouseOver={e => { if(!loading){ e.currentTarget.style.background="#ea6b10"; e.currentTarget.style.transform="translateY(-1px)"; }}}
          onMouseOut={e => { if(!loading){ e.currentTarget.style.background="#f97316"; e.currentTarget.style.transform="translateY(0)"; }}}>
          {loading
            ? <><i className="fa-solid fa-circle-notch fa-spin"/> Generando PDF…</>
            : <><i className="fa-solid fa-file-pdf" style={{ fontSize:"1.1rem" }}/> Generar y Descargar PDF</>}
        </button>
      </div>

      <p style={{ textAlign:"center", marginTop:12,
        fontSize:"0.74rem", color:"#4b5563" }}>
        El PDF se descargará automáticamente al generarse
      </p>

      {/* ── Modal de firma (sin cambios) ── */}
      {showModal && (
        <FirmaModal onConfirm={handleConfirm} onCancel={() => setShowModal(false)}/>
      )}
    </>
  );
}

// ── Hook reutilizable (sin cambios) ───────────────────────────────────────────
export function usePDFIndividual(endpoint, filename) {
  const [loading,     setLoading]     = useState(false);
  const [error,       setError]       = useState("");
  const [showModal,   setShowModal]   = useState(false);
  const [pendingOpts, setPendingOpts] = useState(null);

  function generar(extraQS = "") {
    setShowModal(true);
    setPendingOpts(extraQS);
  }

  function confirmar(opts) {
    setShowModal(false);
    const qs = new URLSearchParams(pendingOpts || "");
    qs.set("incluir_firma", opts.incluirFirma ? "true" : "false");
    if (opts.campoFirma) qs.set("campo_firma", opts.campoFirma);
    descargarPDF(`${endpoint}?${qs}`, filename, setLoading, setError);
  }

  const modal = showModal
    ? <FirmaModal onConfirm={confirmar} onCancel={() => setShowModal(false)}/>
    : null;

  return { loading, error, generar, modal };
}
